import { DriveStep } from "driver.js";

import { getCommonFinalSteps } from "./commonSteps";

export const getBenchmarksTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="benchmarks-header"]',
    popover: {
      title: t("tour.benchmarks.header.title"),
      description: t("tour.benchmarks.header.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="benchmarks-filters"]',
    popover: {
      title: t("tour.benchmarks.filters.title"),
      description: t("tour.benchmarks.filters.description"),
      side: "bottom",
      align: "end",
    },
  },
  {
    element: '[data-tour="benchmarks-overview"]',
    popover: {
      title: t("tour.benchmarks.overview.title"),
      description: t("tour.benchmarks.overview.description"),
      side: "top",
      align: "start",
    },
  },
  {
    element: '[data-tour="benchmarks-table"]',
    popover: {
      title: t("tour.benchmarks.table.title"),
      description: t("tour.benchmarks.table.description"),
      side: "top",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const benchmarksTourConfig = {
  id: "benchmarks" as const,
  steps: getBenchmarksTourSteps,
};
